import {
  Card,
  DataDisplay,
  Grid,
  GridBreak,
  Stack,
  Typography,
  formatPercentTotal,
  getSpacing,
  pn,
} from "@compass/core";
import { Input } from "components";
import { PieChart } from "devextreme-react";
import { Connector, Export, Label, Series, Size } from "devextreme-react/pie-chart";
import { AprEtsTabIIIA as AprResponseModel, ModelPropertyBase } from "generated/openApi";

import "moment-timezone";

export const AprEtsTabIIIA = (props: {
  data: AprResponseModel | undefined;
  totalTabA: number | undefined;
  properties: ModelPropertyBase[] | undefined;
}) => {
  const middleSchoolersField = () => {
    const propertyName = pn<AprResponseModel>("middleSchoolers");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.middleSchoolers} {formatPercentTotal(props.data?.middleSchoolers, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const freshmenField = () => {
    const propertyName = pn<AprResponseModel>("freshmen");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.freshmen} {formatPercentTotal(props.data?.freshmen, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const sophomoresField = () => {
    const propertyName = pn<AprResponseModel>("sophomores");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.sophomores} {formatPercentTotal(props.data?.sophomores, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const juniorsField = () => {
    const propertyName = pn<AprResponseModel>("juniors");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.juniors} {formatPercentTotal(props.data?.juniors, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const seniorsField = () => {
    const propertyName = pn<AprResponseModel>("seniors");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.seniors} {formatPercentTotal(props.data?.seniors, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const alternativeStudentsField = () => {
    const propertyName = pn<AprResponseModel>("alternativeStudents");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.alternativeStudents}{" "}
        {formatPercentTotal(props.data?.alternativeStudents, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const fourthYearStudentsField = () => {
    const propertyName = pn<AprResponseModel>("fourthYearStudents");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.fourthYearStudents}{" "}
        {formatPercentTotal(props.data?.fourthYearStudents, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const fifthYearStudentsField = () => {
    const propertyName = pn<AprResponseModel>("fifthYearStudents");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.fifthYearStudents}{" "}
        {formatPercentTotal(props.data?.fifthYearStudents, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const secondary3AField = () => {
    const propertyName = pn<AprResponseModel>("secondary3A");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.secondary3A} {formatPercentTotal(props.data?.secondary3A, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const other3AField = () => {
    const propertyName = pn<AprResponseModel>("other3A");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.other3A} {formatPercentTotal(props.data?.other3A, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const unknown3AField = () => {
    const propertyName = pn<AprResponseModel>("unknown3A");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.unknown3A} {formatPercentTotal(props.data?.unknown3A, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const totalParticipantsField = () => {
    const propertyName = pn<AprResponseModel>("totalParticipants");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <Stack direction="column">
        <DataDisplay label={property?.displayName}>{props.data?.totalParticipants}</DataDisplay>
        {props.totalTabA != props.data?.totalParticipants && (
          <Typography color="error" variant="caption">
            Your Total Participants does not equal Total Participants in section A
          </Typography>
        )}
      </Stack>
    );
  };

  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" style={{ height: "100%" }}>
        <Typography variant="h5">
          Educational Status of Talent Search Participants (at the time of first service in the reporting year)
        </Typography>
        <Grid container spacing="lg">
          <Grid item xs={6}>
            <Grid container spacing="lg">
              {props.data?.middleSchoolers != null && (
                <Grid item xs={12}>
                  {middleSchoolersField()}
                </Grid>
              )}
              <GridBreak />

              {props.data?.freshmen != null && (
                <Grid item xs={12}>
                  {freshmenField()}
                </Grid>
              )}

              {props.data?.sophomores != null && (
                <Grid item xs={12}>
                  {sophomoresField()}
                </Grid>
              )}

              {props.data?.juniors != null && (
                <Grid item xs={12}>
                  {juniorsField()}
                </Grid>
              )}

              {props.data?.seniors != null && (
                <Grid item xs={12}>
                  {seniorsField()}
                </Grid>
              )}

              {props.data?.alternativeStudents != null && (
                <Grid item xs={12}>
                  {alternativeStudentsField()}
                </Grid>
              )}

              {props.data?.fourthYearStudents != null && (
                <Grid item xs={12}>
                  {fourthYearStudentsField()}
                </Grid>
              )}

              {props.data?.fifthYearStudents != null && (
                <Grid item xs={12}>
                  {fifthYearStudentsField()}
                </Grid>
              )}

              {props.data?.secondary3A != null && (
                <Grid item xs={12}>
                  {secondary3AField()}
                </Grid>
              )}

              {props.data?.other3A != null && (
                <Grid item xs={12}>
                  {other3AField()}
                </Grid>
              )}

              {props.data?.unknown3A != null && (
                <Grid item xs={12}>
                  {unknown3AField()}
                </Grid>
              )}

              <Grid item xs={12}>
                {totalParticipantsField()}
              </Grid>
              <GridBreak />
            </Grid>
          </Grid>

          <GridBreak />

          {/* <Grid item xs={6}>
            <PieChart
              id="pie-tab-a"
              dataSource={props.data?.chartValues}
              palette="Bright"
              title="Participants"
              width="100%"
            >
              <Series argumentField="label" valueField="value">
                <Label visible={true}>
                  <Connector visible={true} width={1} />
                </Label>
              </Series>
            </PieChart>
          </Grid> */}
        </Grid>
      </Stack>
    </Card>
  );
};
